import type { UserGroupsTranslations } from '@/Pages/Groups/types/groupsTranslations.types';

const ptBR: UserGroupsTranslations = {
  title: 'Criar Grupo',
  description: 'Parametrize as informações necessárias para o grupo.',
  editTitle: 'Editar grupo',
  detailsTitle: 'Detalhes do grupo',
  editDescription: 'Confira as informações preenchidas abaixo e altere se necessário.',
  cancelAssignmentsButton: 'Cancelar atribuição de grupo',
  timeline: {
    permissions: {
      title: 'Permissões',
      administrators: 'Administrador',
      viewers: 'Apenas visualização',
    },
    stepOne: {
      title: 'Dados do grupo',
      groupName: {
        label: 'Nome do Grupo',
        placeholder: 'Digite o nome do seu grupo',
        helperText:
          'Campo obrigatório. O nome escolhido deve ser único e diferente de qualquer outro já existente no sistema. Isso garante organização e evita conflitos de informações.',
        errors: {
          required: 'O nome do grupo é obrigatório',
          alreadyExists: 'Este nome de grupo já existe',
        },
      },
      groupDescription: {
        label: 'Descrição',
        placeholder: 'Digite detalhes do grupo',
        helperText: 'Campo opcional para fornecer mais detalhes sobre o grupo.',
      },
    },
    stepTwo: {
      title: 'Usuários',
    },
  },
  transferList: {
    tabs: {
      availables: 'Disponíveis',
      assigned: 'Atribuídos',
    },
    search: {
      placeholder: 'Buscar por nome de usuário',
    },
    saveButton: 'Salvar alterações',
    emptyState: {
      left: {
        title: 'Nenhum usuário disponível',
      },
      right: {
        title: 'Nenhum usuário atribuído',
        description: 'Atribua um ou mais usuários a este grupo',
      },
    },
  },
};

export { ptBR };
